import Box from '@mui/material/Box';
import { getData } from 'clients/Clients';
import ProductCardNewList from 'components-v2/mocules/ProductCardNewList';
import ListProductWithTitle from 'components/mocules/ListProductWithTitle';
import SliderProductBlock from 'components/mocules/Skeleton/SliderProductBlock';
import { EnumProductsDisplayedMobile } from 'constants/Enums/app-settings';
import { EnumBlockCodeTracking } from 'constants/tracking';
import { useCart } from 'context/Cart/CartContext';
import { useGetProductsDisplayedFromAppSettings } from 'hooks/useGetProductsDisplayedFromAppSettings';
import { useIsInViewportOnce } from 'hooks/useIsInViewportOnce';
import { useState } from 'react';
import { getSortedProducts, moveKcbPriorityFirst } from 'services/ProductService';
import useIsKcbVerified from 'hooks/useIsKcbVerified';
import ProductServiceV2 from 'services/ProductServiceV2';
import styles from './styles.module.css';
import SupplierClient from 'clients/SupplierClient';
import { sellerForStore } from 'utils/StoreUtils';

export default function ProductsRecommendation({ product, blockCodeTracking = EnumBlockCodeTracking.PRODUCT_DETAIL_RCM }) {
  const isKcbVerified = useIsKcbVerified();
  const { mapDataProduct } = useCart();

  const [productRecommend, setProductRecommend] = useState([]);
  const [loading, setLoading] = useState(true);

  const MAXIMUM_PRODUCTS_RECOMMENDATION = useGetProductsDisplayedFromAppSettings(EnumProductsDisplayedMobile.PRD_DETAIL_RECOMMENDATION_PRODUCTS);

  const { elementRef } = useIsInViewportOnce({
    callback: async function fetchProductDetailRecommendation() {
      try {
        setLoading(true);
        const recommendations = await ProductServiceV2.getSearchRecommend({ q: { categories: product?.categoryCodes, skuCode: product?.sku } });
        setLoading(false);

        const productsData =
          moveKcbPriorityFirst(
            getSortedProducts(
              mapDataProduct(getData(recommendations)?.filter((item) => item.isAvailable))?.map((prd) => ({ ...prd, isRecommendedByTS: true })),
            ),
            isKcbVerified,
          ) || [];

        const dataWithTracking = productsData.map((item) => ({ ...item, blockCode: blockCodeTracking }));

        let sellerCodes = [];
        dataWithTracking?.forEach((item) => {
          if (item.seller && item.seller.code) sellerCodes.push(item.seller.code);
        });
        if (sellerCodes.length) {
          sellerCodes = [...new Set(sellerCodes)];
          const sellers = await SupplierClient.getSellersV2(sellerCodes).then(getData);
          const sellersMap = new Map(sellers.map((seller) => [seller.code, seller]));
          dataWithTracking?.forEach((item) => {
            item.sellerInfo = sellerForStore(sellersMap.get(item.seller.code), item.storeCode);
          });
        }

        setProductRecommend(dataWithTracking);
      } catch (error) {
        console.error('[Error] fetchProductDetailRecommendation:', error);
        setLoading(false);
      }
    },
  });

  return (
    <section className="products-recommendation" ref={elementRef}>
      {loading ? (
        <SliderProductBlock />
      ) : (
        <Box className={styles.containerPage} style={{ marginTop: '20px' }}>
          <ListProductWithTitle iconWidth="40px" iconHeight="41px" name="Sản phẩm gợi ý" key="flagship-suggestion" viewMore redirect="/products">
            {productRecommend.slice(0, MAXIMUM_PRODUCTS_RECOMMENDATION).map((product, index) => (
              <ProductCardNewList product={product} key={`item-product-${product.slug}`} index={index} />
            ))}
          </ListProductWithTitle>
        </Box>
      )}
    </section>
  );
}
